/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */


/*
	-- LANGUAGE SWITCHER (LangShop) --
*/
document.addEventListener('DOMContentLoaded', function() {
  const LANGUAGE_SWITCHER_ITEM_SELECTOR = '[data-language-switcher-item]';
  const CURRENT_LANGUAGE_SWITCHER_ITEM_SELECTOR = '[data-language-switcher-item][aria-current="true"]';
  const languageSwitcherItems = document.querySelectorAll(LANGUAGE_SWITCHER_ITEM_SELECTOR);

  languageSwitcherItems.forEach(function(languageSwitcherItem) {
    languageSwitcherItem.addEventListener('click', function(event) {
      const selectedLanguageCode = languageSwitcherItem.value;
      const currentLanguageSwitcherItem = document.querySelector(CURRENT_LANGUAGE_SWITCHER_ITEM_SELECTOR);

      if (currentLanguageSwitcherItem?.value === selectedLanguageCode) {
        event.preventDefault();
        return;
      }

      const langShopSdk = window.LangShopSDK;
      if (langShopSdk && typeof langShopSdk.switchLanguage === 'function') {
        event.preventDefault();
        langShopSdk.switchLanguage(selectedLanguageCode);
      }
    });
  });

  //check param Review klaviyo
  const currentUrl = window.location.href;

  if (currentUrl.includes('?utm_source=Klaviyo') && currentUrl.includes('Review')) {

    const reviewButtons = document.querySelectorAll('[data-review-open]');

    if (reviewButtons.length > 0) {
      reviewButtons.forEach(button => button.click());

      const reviewSection = document.querySelector(".product-tabs");
      if (reviewSection) {
        setTimeout(() => {
          reviewSection.scrollIntoView({ behavior: "smooth" });
        }, 1000);
        
      }
    }
  }

  

  // ページネーション機能の修正とスクロール位置調整
  window.boostSdDisableScrollToTop = true;

  function scrollToProductList() {
      // メインビジュアル画像の要素を探す（より広範囲に検索）
      const heroSelectors = [
          '.hero',
          '.main-visual',
          '.hero-image',
          '.banner',
          '.hero-banner',
          '.main-banner',
          '.hero-section',
          '.banner-section',
          '.slideshow',
          '.carousel',
          '.hero-slider',
          '.main-slider',
          '.shopify-section--hero',
          '.shopify-section--banner',
          '.shopify-section--slideshow',
          'section[class*="hero"]',
          'section[class*="banner"]',
          'section[class*="slideshow"]',
          '.page-header',
          '.collection-header',
          '.collection-banner'
      ];
      
      let heroElement = null;
      let usedSelector = '';
      
      for (const selector of heroSelectors) {
          heroElement = document.querySelector(selector);
          if (heroElement) {
              usedSelector = selector;
              break;
          }
      }
      
      if (heroElement) {
          // メインビジュアルの高さを取得
          const heroHeight = heroElement.offsetHeight;
          
          // メインビジュアルの高さ分だけ下げた位置でスクロール停止
          const scrollPosition = heroHeight;
          
          // スクロール位置が適切かチェック
          if (scrollPosition > 0) {
              window.scrollTo({
                  top: scrollPosition,
                  behavior: 'smooth'
              });
          } else {
              console.warn('Hero height is 0 or negative, using fallback');
              // フォールバック処理
              scrollToFallback();
          }
      } else {
          console.warn('Hero element not found, trying alternative approach');
          scrollToFallback();
      }
  }

  // フォールバック処理を別関数に分離
  function scrollToFallback() {
      // フォールバック：メインビジュアル以外の要素を探す
      const fallbackSelectors = [
          '.container',
          '.main-collection .container',
          '.product-facet__product-list',
          '.product-list',
          '.collection-products',
          '.main-collection .product-list',
          '.page-content',
          '.main-collection',
          'main',
          '.main-content',
          '.content',
          '.page-wrapper',
          'section'
      ];
      
      let fallbackElement = null;
      for (const selector of fallbackSelectors) {
          fallbackElement = document.querySelector(selector);
          if (fallbackElement) {
              break;
          }
      }
      
      if (fallbackElement) {
          let offset;
          if (window.innerWidth <= 740) {   
              offset = 80;
          } else if (window.innerWidth <= 999) {
              offset = 100;
          } else {
              offset = 120;
          }
          
          const fallbackOffsetTop = fallbackElement.offsetTop - offset;
          
          window.scrollTo({
              top: fallbackOffsetTop,
              behavior: 'smooth'
          });
      } else {
          console.warn('No suitable element found, scrolling to top');
          window.scrollTo({
              top: 0,
              behavior: 'smooth'
          });
      }
  }

  // ページネーション要素を直接監視（修正版）
  function setupPaginationListeners() {
      // ページネーション要素のセレクター（より広範囲に検索）
      const paginationSelectors = [
          '.pagination a[data-page]',
          '.pagination__nav-item',
          'page-pagination a',
          '[data-pagination]',
          '.pagination a',
          '.pagination button',
          'a[data-page]',
          'button[data-page]'
      ];

      paginationSelectors.forEach(selector => {
          const elements = document.querySelectorAll(selector);

          elements.forEach(element => {
              // 既存のイベントリスナーを削除してから追加
              element.removeEventListener('click', handlePaginationClick);
              element.addEventListener('click', handlePaginationClick);
          });
      });
  }

  // ページネーションクリックハンドラー
  function handlePaginationClick(event) {
      // 少し遅延を設けてコンテンツの更新を待つ
      setTimeout(() => {
          scrollToProductList();
      }, 500);
  }

  // 初期設定
  setupPaginationListeners();

  // ページ読み込み完了後にも再度設定
  window.addEventListener('load', function() {
      setTimeout(() => {
          setupPaginationListeners();
      }, 1000);
  });

  // DOMの変更を監視して新しいページネーション要素を追加
  const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
          if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
              // 新しいページネーション要素が追加された場合
              const hasPaginationElements = Array.from(mutation.addedNodes).some(node => {
                  if (node.nodeType === 1) { // Element node
                      return node.querySelector && (
                          node.querySelector('.pagination') ||
                          node.querySelector('page-pagination') ||
                          node.matches && node.matches('.pagination')
                      );
                  }
                  return false;
              });
              
              if (hasPaginationElements) {
                  setTimeout(() => {
                      setupPaginationListeners();
                  }, 100);
              }
          }
      });
  });

  // ページ全体を監視
  observer.observe(document.body, {
      childList: true,
      subtree: true
  });

  // ページネーション変更イベントも監視（フォールバック）
  document.addEventListener('pagination:page-changed', function(event) {
      setTimeout(() => {
          scrollToProductList();
      }, 300);
  });

  // Boost AIの機能も残しておく（検索結果用）
  if (typeof boostWidgetIntegration !== 'undefined') {
      boostWidgetIntegration.regisCustomization(scrollToProductList, 'filter');
  }
  



	
});


/* =========================================================
   メガメニューがホバー移動中に閉じる問題の対処
   ========================================================= */
(() => {
  const bind = () => {
    document.querySelectorAll('desktop-navigation .header__linklist-item.has-dropdown').forEach((li) => {
      if (li.dataset.megaHoverFix) return;
      const ctrl = li.querySelector('[aria-controls]');
      if (!ctrl) return;
      const dd = document.getElementById(ctrl.getAttribute('aria-controls'));
      if (!dd) return;

      li.dataset.megaHoverFix = '1';
      li.addEventListener('mouseleave', (e) => {
        if (e.relatedTarget && dd.contains(e.relatedTarget)) {
          e.stopImmediatePropagation();
        }
      }, true);
    });
  };

  bind();
  document.addEventListener('shopify:section:load', bind);
})();
